import React from 'react'
import FaIcon from '../../../helpers/fa_icon.js'
import { toJS } from 'mobx'

const AppleMusicStaticPlaylistPreview = ({ url, playlists }) => {
  if(!url) {
    return null
  }

  const playlist = playlists.find(p => p.playlistUrl === url)
  console.log({ playlist: toJS(playlist.songs[0]) })

  if(!playlist) {
    return (
      <FaIcon icon="exclamation-circle" text="Playlist not found or unable to load" />
    )
  }

  if(playlist.songs.length === 0) {
    return (
      <FaIcon icon="exclamation-circle" text="No songs found in this playlist." />
    )
  }

  return (
    <div className="apple-music-container">
      <h3>{playlist.playlistName}</h3>
      <table className="table table-striped">
        <thead> 
          <tr>    
            <th>Track</th>
            <th>Artist</th>
            <th>Album</th>    
          </tr>
        </thead>
        <tbody>
          {playlist.songs.map((track, index) => (
            <tr key={index}>
              <td className="ph-3 font-weight-bold">
                { track.table.track_name }
              </td>
              <td className="ph-3">
                { track.table.artist_name }
              </td>
              <td className="ph-3">
                { track.table.album_name }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const styles = {
  imagePreview: {
    maxHeight: 60,
    width: 'auto',
    maxWidth: '100%',
  }
}



export default AppleMusicStaticPlaylistPreview


